import cmsPages from '@/preload/data/pages.json'
import brandProductsPage from '@/preload/data/brandProductsPage.json'

import { useRoute, useRouter } from '#app'
import { onMounted, onUnmounted } from 'vue'

import useBlogPage from './useBlogPage.js'

/**
 * Adds a new script-tag with either a source or a content to the DOM, returns
 * a promise with the created tag after the script was loaded.
 *
 * @param {*} src URL to load the script-content from
 * @param {string|null} content Content to add within the created script-tag
 * @param {string} target Selector of the element to which the tag should get added
 * @returns {Promise}
 */
function addScript (src, content, target = 'body') {
  return new Promise(resolve => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.onload = () => resolve(script)
    src && (script.src = src)
    content && (script.text = content)
    document.querySelector(target).appendChild(script)
  })
}

/**
 * Adds the given scripts to the current page and removes those when the user
 * leaves the page.
 *
 * @param {array} scripts
 * @returns {Promise}
 */
function handlePageScripts (scripts = []) {
  const addedScripts = []

  onMounted(async () => {
    for (const script of scripts) {
      const scriptTag = await addScript(
        script.src,
        script.content || null,
        script.head ? 'head' : 'body'
      )

      scriptTag && addedScripts.push(scriptTag)
    }
  })

  onUnmounted(() => addedScripts.forEach(scriptTag => scriptTag.remove()))
}

export default function () {
  const route = useRoute()
  const router = useRouter()
  const page = [
    ...cmsPages,
    brandProductsPage,
  ].find(({ path }) => path === route.path)

  const { isBlogPage } = useBlogPage()

  if (!page) {
    !isBlogPage && router.push({ path: '/404' })
    return
  }

  if (import.meta.client && page.scripts) {
    handlePageScripts(page.scripts)
  }

  return page
}
